import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Header from '../componets/Layout/Header'
import Sidebar from '../componets/Layout/Sidebar'
import { getAllPlans } from '../controller'
import { requestHandler } from '../helper'

function PricingDetails() {
    const navigate = useNavigate();
    const [plan, setPlans] = useState([]);
    const [data, setData] = useState('');
    const plans = [
        { planType: 'Basic', timeLimit: 'Month', totalTemplate: 30 },
        { planType: 'Pro', timeLimit: 'Month', totalTemplate: 50 },
        { planType: 'Enterprise', timeLimit: 'Year', totalTemplate: 100 }
    ];

    const handleClick = (plans) => {
        navigate('/pricing', { state: { planData: plans } });
        setData(plans);
    }
    const getSubs = async () => {
        await requestHandler(
            async () => getAllPlans(),
            null,
            (res) => {
                setPlans(res.data);
            },
            () => { }
        )
    }

    useEffect(() => {
        getSubs();
    }, [])
    return (
        <>
            <div>
                <div className='layouy-main'>
                    <div className='sidebar-hide-show'>
                        <Sidebar />
                    </div>
                    <div className='w-100'>
                        <Header />
                        <div className="tebs-title">
                            <p className='active'>Subscription Pricing plan</p>
                        </div>
                        <section>
                            <div className="card main-card">
                                <div className="card modal-form pt-0">
                                    <div class="card-header bg-transparent p-3">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h4 class="add-title">Subscription Pricing Details</h4>
                                        </div>
                                    </div>
                                    <div className="card-body h-100">
                                        <div className="row pricing-details g-3">
                                            {plan.map((p, index) => (
                                                <div className="col-md-6 col-xl-4" key={index}>
                                                    <div className="card">
                                                        <div className="card-body position-relative">
                                                            <div className='edit_icons'>
                                                                <img src="../images/png/edit.png" className='w-100 h-100 p-1' alt="" onClick={() => handleClick(p)} />
                                                            </div>

                                                            <div className='d-flex align-items-center gap-2 mb-1'>
                                                                <p>Plan Type:</p>
                                                                <span style={{ textTransform: 'capitalize' }}>{p.plan_type}</span>
                                                            </div>
                                                            <div className='d-flex align-items-center gap-2 mb-1'>
                                                                <p>Time Limit:</p>
                                                                <span>{p.time_limit === 0 ? '3 Months' : p.time_limit === 1 ? '6 Months' : '12 Months'}</span>
                                                            </div>
                                                            <div className='d-flex align-items-center gap-2 mb-1'>
                                                                <p>Total Template:</p>
                                                                <span>{p.limits}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div >
                </div >
            </div >
        </>

    )

}

export default PricingDetails;